import { UserUserIdAppealGetInputModel } from "./GetInputModel"
import { GetUserUserIdAppealResponse } from "./getResponse"
import { httpGet } from "../../../../../libs/http/httpGet"

export const getUserUserIdAppeal = (
  model: UserUserIdAppealGetInputModel,
): Promise<GetUserUserIdAppealResponse | ""> => {
  return httpGet<GetUserUserIdAppealResponse | "">(
    "/v1/user/{user_id}/appeal",
    model,
  )
}
